"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useBackgroundUploadedOnStageSLI = require("./useBackgroundUploadedOnStageSLI");
Object.keys(_useBackgroundUploadedOnStageSLI).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useBackgroundUploadedOnStageSLI[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useBackgroundUploadedOnStageSLI[key];
    }
  });
});